import { researchEvent } from '~/utils/tracking/researchEvents';
export function useResearchTracking() {
  const { consent } = useCookieConsent();
  return (action: string, slug: string, format?: string) => {
    if (!import.meta.client) return;
    const event = researchEvent(consent.value?.analytics === true, action, slug, format);
    if (!event) return;
    const { event: name, ...parameters } = event;
    if (typeof window.gtag === 'function') window.gtag('event', name, parameters);
    else { window.dataLayer ||= []; window.dataLayer.push(event); }
  };
}
